import React, { useEffect, useState } from 'react';
import CatalogService from '../../services/catalog.service';
import LogoService from '../../services/logo.service';
import { PlusLg, DashLg, ArrowClockwise, ArrowCounterclockwise } from 'react-bootstrap-icons';
import { Spinner, Container, Row, Col } from 'react-bootstrap';
import { set } from 'react-hook-form';
import { isLoggedIn, isSuperAdmin, getSubsite } from '../../reducers/auth';
import { Button } from 'react-bootstrap';
import { resolveImageUrl } from '../../utils/imageUrl';

const AdminImageGallery = ({ productId, selectedDecoration, showAdminControls, forceUpdate, updateAllDecorations, updatePrice, updateDisplayedDecorations }) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [images, setImages] = useState([]);
    const [logoPosiitonSpinner, setLogoPosiitonSpinner] = useState(false);
    const apiUrl = process.env.REACT_APP_LOCALHOST_URL;

    // All decorations for this style and color
    const [productDecorations, setProductDecorations] = useState([]);

    // All decoration image locations for this style and color
    const [decorationImageLocations, setDecorationImageLocations] = useState([]);

    // decorations that are currenly selected
    const [displayedImageLocations, setDisplayedImageLocations] = useState([]);
    const [displayedDecorations, setDisplayedDecorations] = useState([]);
    const [selectedImageLocation, setSelectedImageLocation] = useState([]);

    const [updateMode, setUpdateMode] = useState('color');
    
    const onColorSelect = (color) => {
        // Callback function to handle color selection
    }
    
    const  updateDisplayedLogos = (newSelectedDecoration) => {
        var price = 0;
        var newDisplayDecorations = [];
        for(var i=0; i<displayedImageLocations.length; i++) {
            if(selectedImageLocation && displayedImageLocations[i].id === newSelectedDecoration.id) {
                console.log("Adding selected logo: ", displayedImageLocations[i], newSelectedDecoration);
                newDisplayDecorations.push(newSelectedDecoration);
                price += newSelectedDecoration.decoration_logo.price;
            } else {
                console.log("Adding non selected logo: ", displayedImageLocations[i], newSelectedDecoration);
                newDisplayDecorations.push(displayedImageLocations[i]);
                price += newSelectedDecoration.decoration_logo.price;
            }
        }
        updatePrice(price);
        console.log("Update price: ", price);
        setDisplayedImageLocations(newDisplayDecorations);
    }

    const imageClicked = (e) => {
        // e = Mouse click event.
        var rect = e.target.getBoundingClientRect();
        var x = e.clientX - rect.left; //x position within the element.
        var y = e.clientY - rect.top;  //y position within the element.
        console.log("Left? : " + x + " ; Top? : " + y + "." + "Width" + rect.width + "Height" + rect.height);
    
        var newX = (x / rect.width) * 100;
        var newY = (y / rect.height) * 100;
    
        var newSelectedDecoration = selectedImageLocation;
        newSelectedDecoration.x = newX;
        newSelectedDecoration.y = newY;
        setSelectedImageLocation(newSelectedDecoration);
        updateDisplayedLogos(newSelectedDecoration);
    
      }
    
    const updateModeChanged = (mode) => {
        console.log("UPDATE MODE", mode);
        setUpdateMode(mode);
    }

    const increaseLogoSize = () => {
        var newSelectedDecoration = selectedImageLocation;
        newSelectedDecoration.width += 1;
        newSelectedDecoration.height += 1;
        setSelectedImageLocation(newSelectedDecoration);

        updateDisplayedLogos(newSelectedDecoration);
    }
    const decreaseLogoSize = () => {
        var newSelectedDecoration =selectedImageLocation;
        newSelectedDecoration.width -= 1;
        newSelectedDecoration.height -= 1;
        setSelectedImageLocation(newSelectedDecoration);


        updateDisplayedLogos(newSelectedDecoration);
    }
    const rotateClockwise = () => {
        var newSelectedDecoration = selectedImageLocation;
        newSelectedDecoration.rotate += 2;
        setSelectedImageLocation(newSelectedDecoration);


        updateDisplayedLogos(newSelectedDecoration);
    }
    const rotateCClockwise = () => {
        var newSelectedDecoration = selectedImageLocation;
        newSelectedDecoration.rotate -= 2;
        setSelectedImageLocation(newSelectedDecoration);


        updateDisplayedLogos(newSelectedDecoration);

    }

    const saveLogoPosition = async (e) => {
        console.log("SAVE LOGO POSITION", selectedDecoration);
        var logoPosition = {
            x: selectedImageLocation.x,
            y: selectedImageLocation.y,
            width: selectedImageLocation.width,
            height: selectedImageLocation.height,
            rotate: selectedImageLocation.rotate,
            logo: selectedDecoration.id,
            imageUrl: selectedImage.imageUrl,
            updateMode: updateMode
        }

        setLogoPosiitonSpinner(true);
        await LogoService.updateLogoPositionForStyle(logoPosition);
        setLogoPosiitonSpinner(false);

    }

    const addDecoration = async () => {
        if (!selectedDecoration) return;
        console.log("Adding decoration: ", displayedImageLocations, selectedDecoration);
        const response = await CatalogService.addDecorationToImage(productId, selectedDecoration.deco_location.id, selectedDecoration.decoration_logo.id, selectedImage);
        console.log("Response: ", response);
        var newDecorationImageLocations = [...decorationImageLocations, response];
        setDecorationImageLocations(newDecorationImageLocations);
        setDisplayedImageLocations(getDisplayedDecorations(selectedImage, newDecorationImageLocations, productDecorations, true));
    }

    const removeDecoration = async () => {
        if (!selectedDecoration) return;
        console.log("Adding decoration: ", displayedImageLocations, selectedDecoration);
        const response = await CatalogService.removeDecorationFromImage(productId, selectedDecoration.deco_location.id, selectedDecoration.decoration_logo.id, selectedImage);
        console.log("Response: ", response);

        var newDecorationImageLocations = [...decorationImageLocations];
        // remove selected logo from newDecorationImageLocations
        newDecorationImageLocations = newDecorationImageLocations.filter((decoration) => {
            return decoration.decorationLogoId !== selectedDecoration.decoration_logo.id ||
                decoration.decoLocationId !== selectedDecoration.deco_location.id ||
                decoration.imageUrl !== selectedImage.imageUrl;
        });

        setDecorationImageLocations(newDecorationImageLocations);
        setDisplayedImageLocations(getDisplayedDecorations(selectedImage, newDecorationImageLocations, productDecorations, true));
    }

    const getDisplayedDecorations = (image, decoImageLocations, allDecoMap, checkSelected) => {
        // Single logo mode - only show the selected decoration
        var price = 0;
        var newDisplayedDecorations = [];

        console.log("Single logo mode - selectedDecoration:", selectedDecoration);

        if (checkSelected && selectedDecoration && selectedDecoration.deco_location && selectedDecoration.decoration_logo) {
            // Only show the selected decoration
            var logos = allDecoMap.get(selectedDecoration.deco_location.id);
            if (logos) {
                for (var j = 0; j < logos.length; j++) {
                    if (logos[j].decorationLogoId == selectedDecoration.decoration_logo.id &&
                        logos[j].decoLocationId == selectedDecoration.deco_location.id
                    ) {
                        console.log("Adding single selected logo: ", logos[j]);
                        newDisplayedDecorations.push(logos[j]);
                        break; // Only add one logo
                    }
                }
            }
        } else if (!checkSelected) {
            // Fallback mode - show first decoration only (for initial load)
            const decoLocationKeys = [...allDecoMap.keys()];
            if (decoLocationKeys.length > 0) {
                var logos = allDecoMap.get(decoLocationKeys[0]);
                if (logos && logos.length > 0) {
                    console.log("Adding first logo as fallback: ", logos[0]);
                    newDisplayedDecorations.push(logos[0]);
                }
            }
        }
        // If checkSelected is true but no selectedDecoration, show nothing

        // Match up a image location for each decoration
        var newDisplayDecorations = [];
        for (var i = 0; i < newDisplayedDecorations.length; i++) {
            for (var j = 0; j < decoImageLocations.length; j++) {
                const decoration = decoImageLocations[j];
                if (decoration.decorationLogoId == newDisplayedDecorations[i].decorationLogoId &&
                    decoration.decoLocationId == newDisplayedDecorations[i].decoLocationId &&
                    decoration.imageUrl === image.imageUrl) {

                    console.log("Adding: ", newDisplayedDecorations[i], selectedDecoration,  decoImageLocations[j]);
                    // test if this is selected
                    if (checkSelected && selectedDecoration && selectedDecoration.decoration_logo && selectedDecoration.deco_location &&
                        newDisplayedDecorations[i].decorationLogoId == selectedDecoration.decoration_logo.id &&
                        newDisplayedDecorations[i].decoLocationId == selectedDecoration.deco_location.id) {
                            console.log("Setting Image location: ", decoration, selectedDecoration);

                            setSelectedImageLocation(decoration);
                    }

                    newDisplayDecorations.push(decoration);
                    console.log("New Logo Price: ", decoration.decoration_logo.price);
                    price += decoration.decoration_logo.price;
                }
            }
        }
        console.log("New Logo Price: ", price);
        updatePrice(price);
        updateDisplayedDecorations(newDisplayDecorations);

        return newDisplayDecorations;
    };

    const handleImageClick = (image) => {
        setSelectedImage(image);

        setDisplayedImageLocations(getDisplayedDecorations(image, decorationImageLocations, productDecorations, true));
    };

/*    useEffect(() => {
        const fetchImages = async () => {
            const images = await CatalogService.getImagesForStyleAndColor(productId);
            if (images.images && images.images.length > 0) {
                // Set the first image as the selected image
                setSelectedImage(images.images[0]);
                // Save the images to state
                setImages(images.images);
                var allDecoMap = new Map();
                console.log("All Decorations: ", images.allDecorations);
                for (var i = 0; i < images.allDecorations.length; i++) {
                    var currentArray = allDecoMap.get(images.allDecorations[i].decoLocationId);
                    if (currentArray) {
                        currentArray.push(images.allDecorations[i]);
                        allDecoMap.set(images.allDecorations[i].decoLocationId, currentArray);
                    } else {
                        allDecoMap.set(images.allDecorations[i].decoLocationId, [images.allDecorations[i]]);
                    }
                }
                setProductDecorations(allDecoMap);
                setDecorationImageLocations(images.decorationImageLocations || []);
                updateAllDecorations(images.allDecorations);
                setDisplayedImageLocations(getDisplayedDecorations(images.images[0], images.decorationImageLocations, allDecoMap, false));

            } else {
                console.error("No images found for productId:", productId);
            }
        }
        fetchImages();
    }, []);
*/
    useEffect(() => {
        console.log("FORCE UPDATE");
        const fetchImages = async () => {
            const images = await CatalogService.getImagesForStyleAndColor(productId, true);
            if (images.images && images.images.length > 0) {
                // Set the first image as the selected image
                setSelectedImage(images.images[0]);
                // Save the images to state
                setImages(images.images);
                var allDecoMap = new Map();
                console.log("All Decorations: ", images.allDecorations);
                for (var i = 0; i < images.allDecorations.length; i++) {
                    var currentArray = allDecoMap.get(images.allDecorations[i].decoLocationId);
                    if (currentArray) {
                        currentArray.push(images.allDecorations[i]);
                        allDecoMap.set(images.allDecorations[i].decoLocationId, currentArray);
                    } else {
                        allDecoMap.set(images.allDecorations[i].decoLocationId, [images.allDecorations[i]]);
                    }
                }
                setProductDecorations(allDecoMap);
                setDecorationImageLocations(images.decorationImageLocations || []);
                updateAllDecorations(images.allDecorations);
                setDisplayedImageLocations(getDisplayedDecorations(images.images[0], images.decorationImageLocations, allDecoMap, false));

            } else {
                console.error("No images found for productId:", productId);
            }
        }
        fetchImages();
    }, [forceUpdate]);

    useEffect(() => {
        console.log("SELECTED IAMGE CHANGED");
        const fetchImages = async () => {
            setDisplayedImageLocations(getDisplayedDecorations(selectedImage, decorationImageLocations, productDecorations, true));
            // set selectedImageLocation(selectedDecoration);
        }

        // Fetch images when the component mounts
        if (productId) {
            fetchImages();
        }
    }, [selectedImage, selectedDecoration]);

    useEffect(() => {
        console.log("PRODUCT ID CHANGED", productId);

        const fetchImages = async () => {
            const images = await CatalogService.getImagesForStyleAndColor(productId, true);
            if (images.images && images.images.length > 0) {
                // Set the first image as the selected image
                setSelectedImage(images.images[0]);
                // Save the images to state
                setImages(images.images);
                var allDecoMap = new Map();
                for (var i = 0; i < images.allDecorations.length; i++) {
                    console.log("Current Array: ", images.allDecorations.length);
                    var currentArray = allDecoMap.get(images.allDecorations[i].decoLocationId);
                    if (currentArray) {
                        currentArray.push(images.allDecorations[i]);
                        allDecoMap.set(images.allDecorations[i].decoLocationId, currentArray);
                    } else {
                        allDecoMap.set(images.allDecorations[i].decoLocationId, [images.allDecorations[i]]);
                    }
                }
                setProductDecorations(allDecoMap);

                setDecorationImageLocations(images.decorationImageLocations || []);
                updateAllDecorations(images.allDecorations);
                setDisplayedImageLocations(getDisplayedDecorations(images.images[0], images.decorationImageLocations, allDecoMap));

            } else {
                console.error("No images found for productId:", productId);
            }
        }
        // Fetch images when the component mounts
        if (productId) {
            fetchImages();
        }
    }, [productId]);

    return (
        <div className="image-gallery">
            <div className="main-image">
                <div style={{ display: "inline-block", position: "relative" }}>
                    <img className="bg-image" src={resolveImageUrl(selectedImage?.imageUrl)} width={'100%'} alt={selectedImage?.alt} onClick={imageClicked} />
                    {displayedImageLocations && displayedImageLocations.map((logo, i) => {
                    return <img className="logo-image" src={apiUrl + logo.decoration_logo.imageUrl} width={logo.width + '%'} style={{ left: logo.x + '%', top: logo.y + '%', transform: 'rotate(' + logo.rotate + 'deg)' }}></img>
                    })
                    }
                </div>
            </div>
            <div className="thumbnail-list">
                {images.map((image, index) => (
                    <div style={{ display: "inline-block" }}
                        key={index}

                        onClick={() => handleImageClick(image)}
                    >
                        <img height={100} src={resolveImageUrl(image?.imageUrl)} alt={image.alt} />
                    </div>
                ))}
            </div>
            {isSuperAdmin && showAdminControls && (
                <>
                    <div style={{ marginTop: 20 }}>
                        <Button onClick={addDecoration}>Add selected Logo to this image</Button>
                        <Button variant="danger" onClick={removeDecoration}>Remove selected Logo from this image</Button>
                    </div>

                    <div>
                        <Container>
                            <Row>
                                <Col>
                                    Logo Position and Size:
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    Update Mode:<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="color" name="updateMode" onClick={() => updateModeChanged('color')} />Update this color<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="all" name="updateMode" onClick={() => updateModeChanged('all')} />Update All Colors
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    Size:
                                    <Button onClick={() => increaseLogoSize()}><PlusLg size={20} /></Button>
                                    <Button onClick={() => decreaseLogoSize()}><DashLg size={20} /></Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    Rotation:
                                    <Button onClick={() => rotateClockwise()}><ArrowClockwise size={20} /></Button>
                                    <Button onClick={() => rotateCClockwise()}><ArrowCounterclockwise size={20} /></Button>

                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button onClick={() => saveLogoPosition()} disabled={logoPosiitonSpinner}>{logoPosiitonSpinner && <Spinner size="sm" animation="border" role="status" />} Save Logo Position</Button>
                                </Col>
                            </Row>

                        </Container>
                    </div>
                </>
            )

            }
        </div>
    );
};

export default AdminImageGallery;